<template>
    <div>
        <b-dropdown v-if="params.data.reportGenerated" size="sm" variant="grey" no-caret right>
            <template slot="button-content">
                Download
            </template>
            <b-dropdown-item
                :href="getDownloadUrl(params)"
                target="_blank"
            >
                Download report at hand in
            </b-dropdown-item>
            <b-dropdown-item v-if="!params.data.historic"
                :href="getDownloadSnapshotUrl(params)"
                target="_blank"
            >
                Download latest report
            </b-dropdown-item>

          <b-dropdown-item v-if="userClientHasSection156Active"
                           :href="getDownloadSection156Url(params)"
                           target="_blank"
          >
            Important Fire Safety Information for Residents
          </b-dropdown-item>
        </b-dropdown>
        <b-button v-else variant="grey" size="sm" disabled>
            No report available
        </b-button>
    </div>
</template>

<script>
import Vue from 'vue';
import PropertyAssessment from "@/services/Property/PropertyAssessment";

export default Vue.extend({
  data() {
      return {
          userClientHasSection156Active: this.$store.getters.userClientHasSection156Active,
      }
  },
  methods: {
    getDownloadUrl({ data }) {
      const url = PropertyAssessment.getDownloadLatestReportUrl(data.propertyId, data.propertyAssessmentId);
      return `${url}?token=${this.$store.getters.authToken}`;
    },
    getDownloadSnapshotUrl({ data }) {
      const url = PropertyAssessment.getDownloadSnapshotReportUrl(data.propertyId, data.propertyAssessmentId);
      return `${url}?token=${this.$store.getters.authToken}`;
    },
    getDownloadSection156Url({ data }) {
      const url = PropertyAssessment.getDownloadSection156ReportUrl(data.propertyId, data.propertyAssessmentId);
      return `${url}?token=${this.$store.getters.authToken}`;
    },
  },
});
</script>

<style lang="scss">
.overflow-cell {
    overflow: visible;
}

.ag-row {
    z-index: 0;

    &.ag-row-focus {
        z-index: 1;
    }
}
</style>
